<div
  class="playbook-box pageMaxWidth"
  id="playbookBox"
  [hidden]="playbook == null"
  >
  <!-- Custom css for pb and company -->
  <div [innerHTML]="companyCustomCss | safe : 'html'"></div>
  <div [innerHTML]="companyCustomFonts | safe : 'html'"></div>
  <div [innerHTML]="customCss | safe : 'html'"></div>
  <div [innerHTML]="customFonts | safe : 'html'"></div>
  <div [innerHTML]="coversColorsCss | safe : 'html'"></div>
  <div [innerHTML]="ckeStyle | safe : 'html'"></div>
  <section id="mainPlaybookSection" class="card dark card-playbook">
    <!-- Header bar icons and title -->
    <nav appSwipeout class="head" (click)="clearSelectedEditor(false)">
      <div class="left">
        @if (!inMobileEditor) {
          <a
            [href]="getUrlFunc()"
            id="closePlayBookAddPageDialogId"
            placement="bottom"
            container="body"
            tooltip="Close"
            >
            <span class="icon ic-close" style="bottom: 0px; padding: 0px"
              ><i class="material-icons">clear</i></span
              >
            </a>
          }
          <span
            [ngStyle]="inMobileEditor && { 'margin-left': '10px' }"
            class="title"
            id="pageTitleTxtId"
            >{{ playbook?.title }}</span
            >
          </div>
          <div class="right">
            @if (!templateUrl) {
              <a
                class="playbook-support-link"
                [appCopyClipboard]="copyViewerLinkToClipboard()"
                (copied)="notify($event)"
                placement="bottom"
                container="body"
                tooltip="Copy URL"
                [hidden]="pageFrom"
                >
                <span><i class="material-icons"> link </i></span>
              </a>
            }
            @if (
              playbookLanguages && playbookLanguages.length > 1 && !templateUrl
              ) {
              <a
                (click)="openLanguageModal()"
                class="playbook-support-link"
                placement="bottom"
                container="body"
                tooltip="Manage Languages"
                >
                <span><i class="material-icons">language</i></span>
              </a>
            }
            @if (!templateUrl) {
              <a
                id="expandTag"
                appFullScreen
                class="playbook-support-link"
                >
                @if (screenfull.isEnabled && !screenfull.isFullscreen) {
                  <span
                    placement="bottom"
                    container="body"
                    tooltip="Expand Playbook"
                    >
                    <i class="material-icons">fullscreen</i>
                  </span>
                }
                @if (screenfull.isEnabled && screenfull.isFullscreen) {
                  <span
                    placement="bottom"
                    container="body"
                    tooltip="Collapse Playbook"
                    >
                    <i class="material-icons">fullscreen_exit</i>
                  </span>
                }
              </a>
            }
            <a
              (click)="openSupportMail()"
              [ngStyle]="{ color: playbook && playbook.customCss ? '' : 'white' }"
              class="playbook-support-link marrig-5"
              placement="bottom"
              container="body"
              tooltip="Playbook Support"
              >
              <span><i class="material-icons">help_outline</i></span>
            </a>
            @if (!templateUrl) {
              <div class="edit-mode-icons" [hidden]="pageFrom">
                <a class="edit-icon" (click)="openPlaybookCssModal()">
                  <span
                    class="material-icons"
                    placement="bottom"
                    container="body"
                    tooltip="Edit vPlaybook CSS"
                    >
                    palette
                  </span>
                </a>
              </div>
            }
            @if (!templateUrl) {
              <a
                id="sectionListStartEditingGearIconId"
                (click)="redirectToViewer()"
                placement="bottom"
                container="body"
                tooltip="Done Editing"
                [hidden]="pageFrom"
                >
                <span><i class="material-icons">settings</i></span>
                <span style="margin-right: 10px">Done</span>
              </a>
            }
          </div>
        </nav>

        <!-- Side bar containing pages -->
        <nav
          appSwipeout
          id="side-nav-base"
          class="side"
          (click)="clearSelectedEditor(true)"
          [ngClass]="{ collapsed: isSidebarCollapsed }"
          >
          <div class="scroll-cont">
            <div class="side-cont">
              <div class="side-cont-box sidebar-scroll">
                <ul
                  cdkDropList
                  (cdkDropListDropped)="onItemDrop($event)"
                  class="pages dsg-scrollable"
                  >
                  @for (
                    container of playbook?.containers
                    | filterBy : { type: 1 }
                    | orderBy : 'orderBy'
                    ; track
                    container) {
                    <li
                      [hidden]="container.isPageInDraftMode == true"
                      id="page-{{ container.id }}"
                      class="dsg-scrollabe d-flex"
                      cdkDrag
                      (click)="setContainer(container.id)"
                [ngClass]="{
                  current: container.on,
                  pageInDraft: container.isDraftMode
                }"
                      [cdkDragDisabled]="languageId !== defaultLanguageId"
                      >
                      <a style="width: 35px !important; padding: 8px">
                        <span
                          class="dsg-scrollable icon-"
                          style="background-repeat: no-repeat"
                    [ngClass]="
                      container.customIconAssetId
                        ? 'page-icon-conversation'
                        : 'page-icon-' + container.iconClass
                    "
                          [ngStyle]="container.iconAssetStyle"
                        ></span>
                      </a>
                      <!--  azure issue check -->
                      <a
                        id="page-container-icon-{{ container.id }}"
                        style="vertical-align: middle"
                        >{{ container.title }}</a
                        >
                        <a
                          placement="bottom"
                          container="body"
                          tooltip="Edit Container"
                          class="edit"
                          style="z-index: 1333"
                          (click)="editPage(container.id); $event.stopPropagation()"
                          ><i class="material-icons md-18">create</i></a
                          >
                          @if (languageId === defaultLanguageId) {
                            <a
                              cdkDragHandle
                              class="reorder"
                              placement="bottom"
                              container="body"
                              tooltip="Reorder Item"
                              >
                              <i class="material-icons md-18">open_with</i>
                            </a>
                          }
                        </li>
                      }
                      @if (languageId === defaultLanguageId) {
                        <a
                          (click)="addNewPage()"
                          class="add-container"
                          >Add Page
                          <i class="material-icons md-18">add_circle_outline</i></a
                          >
                        }
                      </ul>
                    </div>
                  </div>
                </div>
              </nav>

              <article class="content d-none d-md-block max-w-100-100px">
                @if (playbook && playbook.coverAssetId) {
                  <img
                    [ngClass]="loadedImages.coverAsset ? 'opacity-1' : 'opacity-0'"
                    (load)="onLoadImage('coverAsset')"
                    class="cover-image opacity-transition"
        [src]="
          getCoverBrandImage(playbook.coverAssetId, 'coverAsset')
            | loadSecureAssets : true
            | async
        "
                    />
                }
                @if (isContentNotification) {
                  <div
                    class="content-notif"
                    style="position: absolute; z-index: 1"
                    >
                    <div class="toast-header">
                      <strong class="me-auto">Playbook Alert</strong>
                      <button
                        type="button"
                        class="ms-2 mb-1 btn-close btn-close-white"
                        aria-label="Close"
                        (click)="closeAlert()"
                      ></button>
                    </div>
                    <div
                      class="toast-body"
          style="
            background-color: white;
            border-bottom-right-radius: 5px;
            border-bottom-left-radius: 5px;
            color: initial;
          "
                      >
                      <span [innerHtml]="content | safe : 'html'"></span>
                    </div>
                  </div>
                }
                @if (playbook && playbook.brandAssetId) {
                  <img
                    [ngClass]="loadedImages.brandAsset ? 'opacity-1' : 'opacity-0'"
                    (load)="onLoadImage('brandAsset')"
        [src]="
          getCoverBrandImage(playbook.brandAssetId, 'brandAsset')
            | loadSecureAssets : true
            | async
        "
                    class="playbook-brand-image brand-image opacity-transition"
                    alt=""
                    />
                }

                <div class="playbook-intro">
                  @if (playbook?.isDisplayPlaybookTitle) {
                    <h1 class="playbook-title">
                      {{ playbook?.title }}
                    </h1>
                  }
                  <div
                    class="playbook-description"
                    [innerHtml]="playbook?.description"
                  ></div>
                </div>
              </article>

              <article
                class="d-flex d-md-none mobile-content justify-content-center overflow-hidden"
                (click)="onUncollapseSidebar()"
                >
                <div class="w-100">
                  @if (
                    playbook && (playbook.mobileCoverAssetId || playbook.coverAssetId)
                    ) {
                    <img
                      [ngClass]="loadedImages.mobileCoverAsset ? 'opacity-1' : 'opacity-0'"
                      (load)="onLoadImage('mobileCoverAsset')"
                      class="cover-image opacity-transition"
          [src]="
            getCoverBrandImage(
              playbook.mobileCoverAssetId || playbook.coverAssetId,
              'coverAsset'
            )
              | loadSecureAssets : true
              | async
          "
                      />
                  }
                  <div class="d-flex justify-content-center">
                    @if (
                      playbook && (playbook.mobileBrandAssetId || playbook.brandAssetId)
                      ) {
                      <img
            [ngClass]="
              loadedImages.mobileBrandAsset ? 'opacity-1' : 'opacity-0'
            "
                        (load)="onLoadImage('mobileBrandAsset')"
            [src]="
              getCoverBrandImage(
                playbook.mobileBrandAssetId || playbook.brandAssetId,
                'brandAsset'
              )
                | loadSecureAssets : true
                | async
            "
                        class="brand-image opacity-transition"
                        alt=""
                        />
                    }
                  </div>
                  <div
                    class="d-flex justify-content-center align-items-center h-50 w-100"
                    >
                    <div class="w-100">
                      @if (playbook?.isDisplayPlaybookTitle) {
                        <h1 class="playbook-title">
                          {{ playbook?.title }}
                        </h1>
                      }
                      <div
                        class="playbook-description mt-2"
                        style="text-indent: 0px; text-align: end"
                        [innerHtml]="playbook?.description"
                      ></div>
                    </div>
                  </div>
                </div>
              </article>
              <!-- Page containers -->
              @for (container of playbook?.containers | orderBy : 'DisplayOrder'; track container) {
                @if (container.on) {
                  <app-container
                    [playbookId]="playbook?.id"
                    id="card-{{ container.id }}"
                    class="card page-card"
                    [containers]="container"
                    [allowConversation]="playbook?.conversationsAvailable"
                    [isParentPageInDraftMode]="container?.isDraftMode"
                    [companyId]="playbook?.companyId"
                    [isCustomCss]="playbook && playbook.customCss ? true : false"
                    >
                  </app-container>
                }
              }
            </section>

            <!-- Resource lists for containers -->
            @for (
              cont of playbook?.containers
              | filterBy : { type: 1, on: true }
              | orderBy : 'displayOrder'
              ; track
              cont) {
              @if (resourceOn) {
                <app-resource-lists
                  [resContainer]="cont"
                  [languageId]="languageId"
                  [companyId]="playbook?.companyId"
                  [pageFrom]="pageFrom"
                  (click)="clearSelectedEditor(true)"
                  >
                </app-resource-lists>
              }
            }
            @for (cont of playbook?.containers; track cont) {
              <app-nav-holder [container]="cont"> </app-nav-holder>
            }
            <app-playbook-toast></app-playbook-toast>
          </div>
          <div id="viewerJsImageContainer" style="display: none"></div>
          <!-- hide mobile editor related changes -->
          <!-- <button class="pointer playbook-navigation-btn" id="mobile_navigation_menu" [hidden]="navigationModal || isShowPlaybookNavigation"
          (click)="getArrayIconStyle(playbook, playbookNavigation)">
          <span><i class="material-icons">
            list_alt
          </i></span>
        </button> -->

        <ng-template #playbookNavigation>
          <div class="modal-content">
            <div class="modal-header">
              Playbook Navigator
              <i
                class="material-icons"
                data-bs-dismiss="modal"
                (click)="closeNavigationModal()"
                >close</i
                >
              </div>
              <div class="modal-body">
                <div class="page-card playbook-navigation" style="height: 380px">
                  <ng-container
          *ngTemplateOutlet="
            pageListRef;
            context: { data: treeViewJson, id: null }
          "
                  ></ng-container>
                </div>
                <ng-template #pageListRef let-data="data" let-id="id">
                  @if (checkNavigationView(id)) {
                    <div class="side">
                      <ul class="pages">
                        @for (
                          page of data
                          | filterBy : { isPage: false }
                          | orderBy : ['order']
                          ; track
                          page) {
                          <li
                            [id]="page.id"
                            style="display: flex"
                            (click)="selectPage(page)"
                            [ngClass]="{ current: checkNavigationView(page.id) }"
                            >
                            <a class="container-title">{{ page.title }}</a>
                          </li>
                        }
                        @for (
                          page of data
                          | filterBy : { isPage: true }
                          | orderBy : ['order']; track
                          page; let i = $index) {
                          <li
                            [id]="page.id"
                            style="display: flex"
                [ngStyle]="{
                  'border-top':
                    id !== null && i == 0 ? '1px solid #96969680' : 'none'
                }"
                            (click)="selectPage(page)"
                [ngClass]="{
                  current: checkNavigationView(page.id),
                  'current-page': i
                }"
                            >
                            @if (id == null) {
                              <a
                                style="width: 35px !important; padding: 8px"
                                >
                                <span
                                  class="icon-"
                                  style="background-repeat: no-repeat"
                    [ngClass]="
                      page.cont.customIconAssetId
                        ? 'page-icon-conversation'
                        : 'page-icon-' + page.cont.iconClass
                    "
                                  [ngStyle]="page.cont.iconAssetStyle"
                                ></span>
                              </a>
                            }
                            <a
                              class="container-title"
                              [ngStyle]="{ 'font-weight': page.isPage ? '700' : 'normal' }"
                              >{{ page.title }}</a
                              >
                            </li>
                          }
                        </ul>
                      </div>
                      @for (page of data; track page) {
                        @if (page.pages.length) {
                          <ng-container
                *ngTemplateOutlet="
                  pageListRef;
                  context: { data: page.pages, id: page.id }
                "
                            >
                          </ng-container>
                        }
                      }
                    }
                  </ng-template>
                </div>
                <div class="modal-footer">
                  <button
                    type="button"
                    class="btn vPlaybookDefaultButton btn__btn-default"
                    data-bs-dismiss="modal"
                    (click)="closeNavigationModal()"
                    >
                    Cancel
                  </button>
                  <button
                    type="button"
                    class="btn btn__btn-default btn__orange"
                    (click)="openSelectedNavigation()"
                    >
                    Go
                  </button>
                </div>
              </div>
            </ng-template>
